/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import assertUnreachable from '../../../../lang/assertUnreachable';
import {VideoCodec, VideoCodecType} from './VideoCodec';

export default class VideoCodecMapping {
  public static convertVideoCodecToVideoCodecType(videoCodec: VideoCodec): VideoCodecType {
    switch (videoCodec) {
      case VideoCodec.H264:
        return 'H264';
      case VideoCodec.VP8:
        return 'VP8';
      case VideoCodec.VP9:
        return 'VP9';
      default:
        assertUnreachable(videoCodec);
    }
  }

  public static convertVideoCodecTypeToVideoCodec(videoCodecType: VideoCodecType): VideoCodec {
    const videoCodecString = videoCodecType.toUpperCase() as keyof typeof VideoCodec;

    switch (videoCodecString) {
      case 'H264':
        return VideoCodec.H264;
      case 'VP8':
        return VideoCodec.VP8;
      case 'VP9':
        return VideoCodec.VP9;
      default:
        assertUnreachable(videoCodecString);
    }
  }
}